// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__UkoA6","loader":"MediumLoader_loader__A3a3v","spinner-c7wet2":"MediumLoader_spinner-c7wet2__5CLLX"};